import {ShapeCommand} from '../../commands.template';

export class FlowlineDeleteLineTextCommand extends ShapeCommand {
  services: any;
  reverseData: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const edge = graph.model.getCell(this.object.flowlineMxKey);

    const lineJson = edge.getJson();

    this.reverseData = lineJson.lineTexts.find(item => item.key === this.object.key);

    const textCell = graph.model.getCell(`${this.object.flowlineMxKey}-${this.object.key}`);

    graph.removeCells([textCell], false);

    const action = {
      deleteLineText: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        key: this.object.key
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const edge = graph.model.getCell(this.object.flowlineMxKey);
    const lineJson = edge.getJson();
    const lineTextCell = this.services.shapeSpawnerSvc.createLineText(this.reverseData, lineJson);

    graph.addCell(lineTextCell, edge);

    const action = {
      addLineText: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        key: this.object.key,
        text: this.reverseData.text,
        position: this.reverseData.position
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }
}
